// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row-margin[data-v-1bbdd990]{grid-gap:0;margin-bottom:25px!important}", "",{"version":3,"sources":["webpack://./resources/js/Components/Customers/ResellerProducts/Form.vue"],"names":[],"mappings":"AACA,6BAEI,UAAA,CADA,4BACA","sourcesContent":["\n.row-margin {\n    margin-bottom: 25px !important;\n    grid-gap: 0\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
